module.exports = __webpack_public_path__ + "static/media/scene-hiker.a2bd9198.svg";